export function ZLogo({ size = 32 }) {
  return (
    <div
      className="flex items-center justify-center rounded-md font-display font-extrabold"
      style={{
        width: size,
        height: size,
        background: "linear-gradient(135deg, #0B6BCB, #0A5CB0)",
        color: "#FFFFFF",
        fontSize: size * 0.6,
        boxShadow: "0 0 18px rgba(41,182,246,0.35)",
      }}
      data-testid="brand-logo"
    >
      Z
    </div>
  );
}
